import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import { IconChevronRight } from "./Icons";

export function PageHeader({
  breadcrumb,
  title,
  subtitle,
  badge,
  actions,
}: {
  breadcrumb?: { label: string; to?: string }[];
  title: ReactNode;
  subtitle?: ReactNode;
  badge?: ReactNode;
  actions?: ReactNode;
}) {
  return (
    <header className="page-header">
      {breadcrumb && breadcrumb.length > 0 ? (
        <nav className="page-header__crumb" aria-label="Breadcrumb">
          {breadcrumb.map((c, i) => (
            <span key={i} className="page-header__crumb-item">
              {i > 0 ? <IconChevronRight className="page-header__crumb-sep" /> : null}
              {c.to ? (
                <Link to={c.to}>{c.label}</Link>
              ) : (
                <span className="page-header__crumb-current">{c.label}</span>
              )}
            </span>
          ))}
        </nav>
      ) : null}
      <div className="page-header__row">
        <div>
          <h1 className="page-header__title">{title}</h1>
          {subtitle ? <div className="page-header__subtitle">{subtitle}</div> : null}
        </div>
        <div className="page-header__aside">
          {badge}
          {actions}
        </div>
      </div>
    </header>
  );
}
